const { REACT_APP_BASE_URL = '' } = process.env

export const NAMESPACE = 'banking'

export const ENDPOINTS = {
  FETCH_PARTY_ERRORS: `${REACT_APP_BASE_URL}/banking/v2/parties/:partyId`,
  FETCH_PARTIES_ERRORS: `${REACT_APP_BASE_URL}/banking/v2/parties`,
}
